/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Store from '@apply/store';
import LoadPanel from 'devextreme-react/load-panel';
import { alertModal } from '@apply/ui';
import { BusinessAndPeopleApi } from '@apply/api';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';
import { EditUmbrellaBusinessModal } from './modals/EditUmbrellaBusinessModal';

export interface BusinessAndPeopleUmbrellaBusinessProps {
    updateCurrentBusiness: (selectedBusiness: number) => void;
    applicationInsights: ApplicationInsights;
}

const BusinessAndPeopleUmbrellaBusinessPanel: React.FC<BusinessAndPeopleUmbrellaBusinessProps> = (props) => {
    const businessAndPeopleApi = new BusinessAndPeopleApi.BusinessAndPeopleApi(props.applicationInsights);
    const [topLevelBusinesses, set_topLevelBusinesses] = useState([]);
    const [selectedTopLevelBusiness, set_selectedTopLevelBusiness] = useState();
    const [borrowerEntityWithoutTopLevelBusinessExist, set_borrowerEntityWithoutTopLevelBusinessExist] = useState(false);
    const [loadingMessage, set_loadingMessage] = useState('');
    const [loadingOpen, set_loadingOpen] = useState(false);
    const [umbrellaBusinessEditorOpen, set_umbrellaBusinessEditorOpen] = useState(false);

    const styles = {
        topLevelBusinessPanel: {
            paddingLeft: '10px',
            paddingRight: '10px',
            width: '100%',
        },
    };

    const onUmbrellaBusinessClose = async () => {
        set_umbrellaBusinessEditorOpen(false);
        loadUserBusinesses();
    };

    const onClickEditUmbrellaBusiness = (event) => {
        event.preventDefault();
        event.stopPropagation();
        set_umbrellaBusinessEditorOpen(true);
    };

    const onClickAddUmbrellaBusiness = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        set_selectedTopLevelBusiness(0);
        set_umbrellaBusinessEditorOpen(true);
    };

    useEffect(() => {
        props.updateCurrentBusiness(selectedTopLevelBusiness);
    }, [selectedTopLevelBusiness]);

    useEffect(() => {
        loadUserBusinesses();
    }, []);

    const renderBusinessAction = () => {
        if (selectedTopLevelBusiness && selectedTopLevelBusiness > 0) {
            return (
                <button
                    className='button gridActionColumnButton'
                    title='Edit Business'
                    onClick={(event) => onClickEditUmbrellaBusiness(event)}
                >
                    <FontAwesomeIcon icon={faEdit} />
                </button>
            );
        } else if (!topLevelBusinesses || topLevelBusinesses.length == 0) {
            return (
                <button
                    className='button gridActionColumnButton'
                    title='Add Business Information'
                    style={{ background: 'red' }}
                    onClick={(event) => onClickAddUmbrellaBusiness(event)}
                >
                    <FontAwesomeIcon icon={faEdit} /> Add Business Information
                </button>
            );
        }
    };

    const renderBusinessInfo = () => {
        if (selectedTopLevelBusiness && selectedTopLevelBusiness > 0) {
            //Business Name
            const business = topLevelBusinesses.find((f) => f.companyId === selectedTopLevelBusiness);
            return (
                <span
                    style={{
                        paddingLeft: '20px',
                        paddingRight: '20px',
                        color: 'darkblue',
                    }}
                >
                    {business?.name}
                </span>
            );
        }
    };

    const onMultipleBusinessesConfirm = () => {
        window.location.href = '/home';
    };

    const onBusinessWithNonLinkedBorrowerEntities = () => {
        window.location.href = '/home';
    };

    const loadUserBusinesses = async () => {
        try {
            set_loadingOpen(true);
            set_loadingMessage('Loading...');

            const responseNoTopLevel = await businessAndPeopleApi.getDoesBorrowerEntityWithoutUmbrellaCompanyExist();
            if (responseNoTopLevel.statusCode !== 200) {
                alertModal({
                    message: 'Failed to load Borrower Entities. Please try again.',
                });
            }
            set_borrowerEntityWithoutTopLevelBusinessExist(responseNoTopLevel.result);

            const responseBusinesses = await businessAndPeopleApi.getBorrowerBusinesses();
            if (responseBusinesses.statusCode !== 200) {
                alertModal({
                    message: 'Failed to load Borrower Entities. Please try again.',
                });
            }

            let result = responseBusinesses.result;
            if (result) {
                if (result.length >= 1 && responseNoTopLevel.result) {
                    alertModal({
                        title: 'Business Association',
                        message:
                            'One or more Borrower Entities linked to this account are not yet associated with your Business. </br></br> Please contact BFI for assistance.',
                        onConfirm: () => {
                            onBusinessWithNonLinkedBorrowerEntities();
                        },
                    });
                } else if (result.length > 1) {
                    alertModal({
                        title: 'Multiple Businesses',
                        message:
                            'Multiple Parent Businesses are associated with this account. </br></br> Please contact BFI for assistance.',
                        onConfirm: () => {
                            onMultipleBusinessesConfirm();
                        },
                    });
                } else if (result.length == 1) {
                    set_selectedTopLevelBusiness(result[0].id);
                }
                set_topLevelBusinesses(result);
            }
        } catch (ex) {
            set_topLevelBusinesses([]);
            alertModal({
                message: 'Failed to load Borrower Entities. Please try again.',
            });
        } finally {
            set_loadingOpen(false);
            set_loadingMessage('');
        }
    };

    useEffect(() => {
        if (!selectedTopLevelBusiness && topLevelBusinesses.length === 1) {
            set_selectedTopLevelBusiness(topLevelBusinesses[0].companyId);
        } else {
            set_selectedTopLevelBusiness(0);
        }
    }, [topLevelBusinesses]);

    return (
        <>
            <div style={styles.topLevelBusinessPanel}>
                <div style={{ display: 'flex', paddingTop: '10px' }}>
                    <div>
                        <h5>Business: {renderBusinessInfo()}</h5>
                    </div>
                    <div style={{ paddingLeft: '10px' }}>{renderBusinessAction()}</div>
                </div>
            </div>
            <LoadPanel
                hideOnOutsideClick={false}
                visible={loadingOpen}
                message={loadingMessage}
            />
            <EditUmbrellaBusinessModal
                companyId={selectedTopLevelBusiness}
                isOpen={umbrellaBusinessEditorOpen}
                onCloseCallback={onUmbrellaBusinessClose}
                applicationInsights={props.applicationInsights}
            />
        </>
    );
};

export default BusinessAndPeopleUmbrellaBusinessPanel;
